import { render, staticRenderFns } from "./BasisMapDemo.vue?vue&type=template&id=bbc4179a&scoped=true"
import script from "./BasisMapDemo.vue?vue&type=script&lang=js"
export * from "./BasisMapDemo.vue?vue&type=script&lang=js"
import style0 from "./BasisMapDemo.vue?vue&type=style&index=0&id=bbc4179a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4179a",
  null
  
)

export default component.exports